import { render, staticRenderFns } from "./iconFacebook.vue?vue&type=template&id=9b690558&scoped=true"
import script from "./iconFacebook.vue?vue&type=script&lang=js"
export * from "./iconFacebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b690558",
  null
  
)

export default component.exports